import { formRules } from "../../../../../config/validations/formRules";
import { validations } from "../../../../../config/validations/validations";

export const rules: any = {
  name: () => formRules.name(),
  last_name: () => formRules.last_name(),
  invite_name: (min?: number, max?: number, field?: string) => [
    validations.min.text(1, field),
    validations.max.text(max, field),
  ],
  invite_last_name: (min?: number, max?: number, field?: string) => [
    validations.min.text(1, field),
    validations.max.text(max, field),
  ],
  email: (field?: string) => [
    validations.required.text(field),
    validations.email(field),
  ],
  mobileNumber: () => formRules.mobileNumber(),
  roleId: (field?: string) => [validations.required.select(field)],
  password: (field?: any) => [
    validations.required.text(field),
    validations.pattern.password(field),
    validations.min.text(8),
    validations.max.text(50),
  ],
  dateOfBirth: (field?: string) => [validations.required.text(field)],
  gender: (field?: string) => [validations.required.select(field)],
  zipCode: (field?: any) => [validations.required.text(field)],
  confirmPassword: (field?: string) => [
    validations.required.text(field),
    ({ getFieldValue }:any) => ({
      validator(rule:any, value:any) {
        if (!value || getFieldValue("password") === value) {
          return Promise.resolve();
        }
        return Promise.reject(
          "New Password and Confirm Password does not match."
        );
      },
    }),
  ],
};
